import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CityListComponent } from './city-list/city-list.component';
import { CityRoutingModule } from './city-routing.module';
import { SharedModule } from '../shared/shared.module';
import { CityDetailsComponent } from './city-details/city-details.component';
import { AreaDetailsComponent } from './area-details/area-details.component';
import { MaterialModule } from '../shared/material.module';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { AddCityComponent } from './add-city/add-city.component';
import { DistrictComponent } from './district/district.component';
import { SubdivisionComponent } from './subdivision/subdivision.component';
import { VillageComponent } from './village/village.component';



@NgModule({
  declarations: [
    CityListComponent,
    CityDetailsComponent,
    AreaDetailsComponent,    
    AddCityComponent,
    DistrictComponent,    
    SubdivisionComponent,
    VillageComponent,
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    CityRoutingModule,
    ReactiveFormsModule,
    SharedModule,
    MaterialModule
  ]
})
export class CityModule { }
